import { render, staticRenderFns } from "./EditorIndex.vue?vue&type=template&id=6b9a5e82&scoped=true&"
import script from "./EditorIndex.vue?vue&type=script&lang=js&"
export * from "./EditorIndex.vue?vue&type=script&lang=js&"
import style0 from "./EditorIndex.vue?vue&type=style&index=0&id=6b9a5e82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a5e82",
  null
  
)

export default component.exports